<template>
    <v-app>
        <v-main>
            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Daftar Permintaan Pengeluaran</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                            <i class="fa fa-plus-square"></i>
                                            Tambah
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <v-dialog ref="dialog" v-model="modaltgl"
                                                        :return-value.sync="tanggal_query" persistent width="290px">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="tanggal_query" readonly
                                                                v-bind="attrs" v-on="on"
                                                                label="Bulan Permintaan Perubahan" outlined dense
                                                                return-object class="w-100"
                                                                append-icon="mdi-calendar"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="tanggal_query" type="month" scrollable
                                                            min="2022-08" :max="dateMax">
                                                            <v-spacer></v-spacer>
                                                            <v-btn text color="primary" @click="modaltgl = false">
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn text color="primary"
                                                                @click="ubahTanggalTampil($refs)">
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="row">
                                                <div class="progress-group">
                                                    <p class="subtitle">Informasi Permintaan Pengeluaran:</p>
                                                    <div class="background-pending">
                                                        <span style="color: #494f56">
                                                            Menunggu Aproval: {{ jumlahbelum | toCurrency }}
                                                        </span>
                                                    </div>
                                                    <div class="background-rejected">
                                                        <span style="color: #494f56">
                                                            Ditolak: {{ jumlahtolak | toCurrency }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="row">
                                                <div class="progress-group">
                                                    <p class="subtitle">&nbsp;</p>
                                                    <div class="background-upload">
                                                        <span style="color: #494f56">
                                                            Upload Bukti: {{ jumlahupload | toCurrency }}
                                                        </span>
                                                    </div>
                                                    <div class="background-accept">
                                                        <span style="color: #494f56">
                                                            Diterima: {{ jumlahaccept | toCurrency }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <v-text-field v-model="cari_dt_plg" label="Cari" class="w-100 col-md-2 ml-auto mb-2"
                                        outlined dense hide-details>
                                    </v-text-field>
                                    <v-data-table :headers="headers"
                                        :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }" :items="datas"
                                        :items-per-page="25" item-key="id" sort-by="noRows" class="elevation-1 "
                                        show-group-by :search="cari_dt_plg">

                                        <template v-slot:item.noRows="{ item }">
                                            {{ datas.indexOf(item) + 1 }}
                                        </template>

                                        <template v-slot:item.created_at="{ item }">
                                            <div class="text-start">
                                                {{
                                                    item.created_at | indoDate
                                                }}
                                            </div>
                                        </template>

                                        <template v-slot:item.jumlah="{ item }">
                                            <div class="text-right font-weight-bold">
                                                {{
                                                    item.jumlah | toCurrency
                                                }}
                                            </div>
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <div class="text-start font-weight-bold">
                                                <span class="badge badge-danger"
                                                    v-if="item.statusnya.includes(2)">Ditolak</span>
                                                <span class="badge badge-success"
                                                    v-else-if="item.statusnya.every((val, i, arr) => val === arr[0] && val == 1)">Diterima</span>
                                                <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                            </div>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <button class="btn btn-xs btn-primary"
                                                @click="bukaDetailApprovalModal(item.pejabat_approval_permintaan)"
                                                title="Lihat Detail Approval">
                                                <i class="fas fa-search text-white"></i>
                                            </button>
                                            <button
                                                v-if="item.statusnya.every((val, i, arr) => val === arr[0] && val == 1) && item.is_selesai != 1"
                                                class="btn btn-xs btn-warning" @click="uploadModal(item)"
                                                title="Upload Bukti">
                                                <i class="fas fa-upload"></i>
                                            </button>
                                            <button
                                                v-else-if="item.statusnya.includes(2) || item.statusnya.every((val, i, arr) => val === arr[0] && val == 0)"
                                                class="btn btn-xs btn-danger" @click="deletePermintaan(item.id)"
                                                title="Hapus Permintaan">
                                                <i class="fas fa-trash text-white"></i>
                                            </button>
                                        </template>

                                        <template v-slot:body.append>
                                            <tr>
                                                <td colspan="4" class="text-right"><strong>Total</strong></td>
                                                <td class="text-right font-weight-bold">{{ jumlahnya | toCurrency }}
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-slot:no-data>
                                            <h6>Data Tidak Ditemukan</h6>
                                        </template>
                                    </v-data-table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew"
                        aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Tambah Pengeluaran Periode {{ tanggal_query }}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <form @submit.prevent="createData()" enctype="multipart/form-data">
                                    <div class="modal-body">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Kas Kantor</label>
                                                    <select name="kantor_id" v-model="form.kantor_id" id="kantor_id"
                                                        class="form-control"
                                                        :class="{ 'is-invalid': adaeror['kantor_id'] }" required
                                                        @change="changeKantor()">
                                                        <option value="" selected disabled>-- PILIH KANTOR --</option>
                                                        <option v-for="row in kantor_list" :key="row.id"
                                                            :value="{ id: row.id, text: row.value, saldo: row.saldo, maksimal: row.maksimal }"
                                                            :selected="row.id == form.kantor_id.id">
                                                            {{ row.value }}
                                                        </option>
                                                    </select>
                                                    <small v-if="adaeror['kantor_id']" class="text-danger">
                                                        {{ adaeror["kantor_id"].join(', ') }}
                                                    </small>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Saldo</label>
                                                    <h5>{{ this.form.kantor_id.saldo | toCurrency }}</h5>
                                                    <small>Rp Saldo Kantor Saat Ini</small>
                                                    <small v-if="adaeror['maksimal']" class="text-danger">
                                                        {{ adaeror["maksimal"].join(', ') }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label>Kategori Pengeluaran</label>
                                            <select name="kategori" v-model="form.kategori" id="kategori"
                                                class="form-control" :class="{ 'is-invalid': adaeror['kategori'] }"
                                                required @change="countBudgetnya()" :disabled="kantorBelumTerpilih">
                                                <option value="" disabled selected>-- PILIH KATEGORI PENGELUARAN --
                                                </option>
                                                <option v-for="row in kategori_list" :key="row.id"
                                                    :value="{ id: row.id, text: row.kategori_nama, sisa: parseInt(row.budget - row.realisasi), budget: row.budget }"
                                                    :selected="row.id == form.kategori.id">
                                                    {{ row.kategori_nama }}
                                                </option>
                                            </select>
                                            <small v-if="adaeror['kategori']" class="text-danger">
                                                {{ adaeror["kategori"].join(', ') }}
                                            </small>
                                        </div>

                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <label>Jumlah</label>
                                                    <!-- <input type="number" @keydown="preventArrow($event)" v-model="form.jumlah" name="jumlah" 
                                                        class="form-control" :class="{ 'is-invalid': adaeror['jumlah'] }" :min="0"
                                                        :max="this.form.kantor_id.saldo < this.form.kategori.sisa ? this.form.kantor_id.saldo : this.form.kategori.sisa"
                                                        required :disabled="kategoriBelumTerpilih"> -->
                                                    <input type="text" @keydown="preventArrow($event)" name="jumlah"
                                                        class="form-control" :value="formatRupiah(form.jumlah)"
                                                        @input="onJumlahInput"
                                                        :class="{ 'is-invalid': adaeror['jumlah'] }" :min="0"
                                                        :max="this.form.kategori.sisa" required
                                                        :disabled="kategoriBelumTerpilih">
                                                    <small v-if="adaeror['jumlah']" class="text-danger">
                                                        {{ adaeror["jumlah"].join(', ') }}
                                                    </small>
                                                </div>
                                                <div class="col-md-4">
                                                    <label>Maksimal Penarikan</label>
                                                    <!-- <h5>{{ (this.form.kantor_id.saldo < this.form.kategori.sisa ?
                                                        this.form.kantor_id.saldo : this.form.kategori.sisa) | toCurrency }}</h5> -->
                                                    <h5>{{ this.form.kategori.sisa |
                                                        toCurrency }}</h5>
                                                    <small v-if="adaeror['sisa']" class="text-danger">
                                                        {{ adaeror["sisa"].join(', ') }}
                                                    </small>
                                                </div>
                                                <div class="col-md-4">
                                                    <label>Budget</label>
                                                    <h5>{{ this.form.kategori.budget | toCurrency }}</h5>
                                                    <small v-if="adaeror['budget']" class="text-danger">
                                                        {{ adaeror["budget"].join(', ') }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label>Keterangan</label>
                                            <textarea v-model="form.keterangan" id="keterangan" name="keterangan"
                                                style="resize:none" rows="5" class="form-control"
                                                :class="{ 'is-invalid': adaeror['keterangan'] }" required
                                                :disabled="kategoriBelumTerpilih"></textarea>
                                            <small v-if="adaeror['keterangan']" class="text-danger">
                                                {{ adaeror["keterangan"].join(', ') }}
                                            </small>
                                        </div>

                                        <div class="form-group">
                                            <label>Pejabat Approval</label>
                                            <div class="form-check" v-for="row in pejabat_list">
                                                <input type="checkbox" v-model="form.pejabat_approval"
                                                    :id="'ch' + row.id" :value="row.id" :name="'ch' + row.id"
                                                    class="form-check-input" :disabled="kategoriBelumTerpilih">
                                                <label :for="'ch' + row.id" class="form-check-label">
                                                    {{ row.name }}
                                                </label>
                                            </div>
                                            <div v-if="!pejabat_list.length">
                                                <span class="text-danger">Gagal Mengambil Pejabat Approval</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-primary">Tambah!</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog"
                        aria-labelledby="KeteranganModal" aria-hidden="true" data-backdrop="static"
                        data-keyboard="false">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title"> Keterangan Pengeluaran </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                        @click="closeKeteranganModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{ tampilKet }}
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                        @click="closeKeteranganModal()">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="DetailApprovalModal" tabindex="-1" role="dialog"
                        aria-labelledby="DetailApprovalModal" aria-hidden="true" data-backdrop="static"
                        data-keyboard="false">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Detail Approval</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                        @click="closeDetailApprovalModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div class="modal-body">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Nama Pejabat</th>
                                                <th style="text-align: center;">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="tampilPejabat" v-for="(row, index) in tampilPejabat">
                                                <td>
                                                    {{ row.name }}
                                                    <div v-if="row.status == 2" class="col-12 text-red mt-1">

                                                    </div>
                                                    <p v-if="row.status == 2" class="text-red"> <strong>ALASAN
                                                            :</strong> {{ row.keterangan
                                                            }}</p>
                                                </td>
                                                <td style="text-align: center;">
                                                    <span class="badge badge-danger"
                                                        v-if="row.status == 2">Ditolak</span>
                                                    <span class="badge badge-success"
                                                        v-else-if="row.status == 1">Diterima</span>
                                                    <span class="badge badge-warning" v-else>Menunggu Aproval</span>
                                                </td>
                                            </tr>
                                            <tr v-else>
                                                <td colspan="2" class="text-center">
                                                    <h6>Gagal mengambil data pejabat aproval</h6>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                        @click="closeDetailApprovalModal()">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="uploadBukti" tabindex="-1" role="dialog" aria-labelledby="uploadBukti"
                        aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Upload Bukti Pengeluaran</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <form @submit.prevent="uploadFile()" enctype="multipart/form-data">
                                    <div class="modal-body">
                                        <div class="form-group">
                                            <label>Upload Bukti</label>
                                            <div class="custom-file">
                                                <input type="file" id="file" name="file" class="custom-file-input"
                                                    @change="onUploadFile" :class="{ 'is-invalid': adaeror['file'] }"
                                                    accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                                <label class="custom-file-label" for="file">
                                                    {{ filename ? filename : 'Choose File' }}
                                                </label>
                                                <small v-if="adaeror['file']" class="text-danger">
                                                    {{ adaeror["file"].join(', ') }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-primary">Upload!</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </v-main>
    </v-app>
</template>

<script>
import { formatRupiah, parseRupiah } from '../../helpers/format'
export default {
    data() {
        return {
            datas: [],
            form: new Form({
                jumlah: '',
                kategori: '',
                keterangan: '',
                kantor_id: '',
                pejabat_approval: [],
                oleh: '',
                id_edit: '',
                //tanggal:'',
            }),
            filename: '',
            file: '',
            kategori_list: [],
            kantor_list: [],
            pejabat_list: [],
            adaeror: [],
            menu: false,
            tampilPejabat: '',
            tampilKet: '',
            modaltgl: false,
            dateMax: new Date().toISOString().substr(0, 7),
            tanggal_query: new Date().toISOString().substr(0, 7),
            tanggal_tampil: '',
            jumlahnya: 0,
            jumlahaccept: 0,
            jumlahtolak: 0,
            jumlahbelum: 0,
            jumlahupload: 0,
            kantorBelumTerpilih: true,
            kategoriBelumTerpilih: true,
            cari_dt_plg: '',
            headers: [
                { text: 'No', value: 'noRows', sortable: true, groupable: false, },
                { text: 'Tanggal Dibuat', value: 'created_at', groupable: false, },
                { text: 'Ket', value: 'keterangan', groupable: false, },
                { text: 'Kategori', value: 'kategori_keuangan_permintaan.value', groupable: false, },
                { text: 'Jumlah', value: 'jumlah', groupable: false, },
                { text: 'User', value: 'user_permintaan.name', groupable: false, },
                { text: 'Status', value: 'status', groupable: false, },
                { text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-right" },
            ],
        }
    },

    methods: {
        formatRupiah,
        parseRupiah,
        onJumlahInput(e) {
            const angka = this.parseRupiah(e.target.value)
            this.form.jumlah = angka
            e.target.value = this.formatRupiah(angka)
        },
        changeKantor() {
            Object.assign(this, {
                kantorBelumTerpilih: false,
                kategoriBelumTerpilih: true,
            });
            this.form.kategori = '';
            this.loadKategori();
        },

        countBudgetnya() {
            this.kategoriBelumTerpilih = false;
        },

        countJumlahnya() {
            this.jumlahnya = 0;
            this.jumlahtolak = 0;
            this.jumlahaccept = 0;
            this.jumlahupload = 0;
            this.jumlahbelum = 0;

            this.datas.forEach(val => {
                const jumlah = parseFloat(val.jumlah);
                this.jumlahnya += jumlah;

                if (val.statusnya.includes(2)) {
                    this.jumlahtolak += jumlah;
                } else if (val.statusnya.every(status => status === 1) && val.is_selesai) {
                    this.jumlahaccept += jumlah;
                } else if (val.statusnya.every(status => status === 1) && !val.is_selesai) {
                    this.jumlahupload += jumlah;
                } else {
                    this.jumlahbelum += jumlah;
                }
            });
        },

        onUploadFile(e) {
            console.log("File input event:", e);
            const file = e.target.files[0];

            if (!file) {
                this.filename = "";
                this.file = null;
                return;
            }

            const allowedExtensions = /\.(jpe?g|png|gif|pdf|xls|xlsx|csv)$/i;

            if (!allowedExtensions.test(file.name)) {
                this.filename = "ERROR! Hanya PDF, Image (JPEG/JPG/PNG), atau Excel (XLS/XLSX/CSV) yang diperbolehkan.";
                this.file = null;

                // Tambahkan notifikasi agar user tahu filenya ditolak
                Toast.fire({
                    icon: "warning",
                    title: "Format file tidak didukung!"
                });

                return;
            }

            // Jika file valid, simpan datanya
            this.filename = file.name;
            this.file = file;

            console.log("File uploaded:", this.file);
        },


        uploadModal(data) {

            this.form.reset();
            this.form.jumlah = data.jumlah;
            this.form.kategori = data.kategori_id;
            this.form.keterangan = data.keterangan;
            this.form.kantor_id = data.kantor_id;
            this.form.oleh = data.created_by;
            this.form.id_edit = data.id;
            this.form.tgl_permintaan = data.created_at;

            this.adaeror = [];
            this.filename = "";
            this.file = "";
            $('#uploadBukti').modal('show');

        },

        uploadFile() {
            this.$Progress.start();

            if (!this.file) {
                Toast.fire({
                    icon: "warning",
                    title: "Pilih file terlebih dahulu sebelum upload!"
                });
                this.$Progress.fail();
                return;
            }

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('datanya', JSON.stringify(this.form));
            axios.post('api/keuangan/approvalAkhir', formData, config)
                .then((data) => {
                    if (data.data.success) {
                        $('#uploadBukti').modal('hide');
                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.loadData();
                        this.adaeror = [];
                        this.filename = "";
                        this.file = null; // Reset file setelah berhasil upload
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occurred! Please try again'
                        });

                        this.$Progress.fail();
                    }
                })
                .catch(e => {
                    this.adaeror = e.response?.data?.errors || [];
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: e.response?.data?.data || "Terjadi kesalahan!"
                    });
                }
                );
        },

        getStatusnya() {

            Object.entries(this.datas).forEach(([key, val]) => { this.datas[key]['statusnya'] = val.pejabat_approval_permintaan.map(elm => elm.status) });
        },

        getBulan(tanggal) {
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

            return (bulan[tgltemp.getMonth()] + " " + tahun);
        },

        ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadData();
        },

        bukaKeteranganModal(id) {
            this.tampilKet = id;
            $('#KeteranganModal').modal('show');
        },

        closeKeteranganModal() {
            this.tampilKet = '';
            $('#KeteranganModal').modal('hide');
        },

        bukaDetailApprovalModal(pejabat) {
            this.tampilPejabat = pejabat;
            $('#DetailApprovalModal').modal('show');
        },

        closeDetailApprovalModal() {
            this.tampilPejabat = '';
            $('#DetailApprovalModal').modal('hide');
        },

        getResults(page = 1) {

            this.$Progress.start();

            axios.get('api/keuangan/permintaan?page=' + page).then(({ data }) => (this.datas = data.data));

            this.$Progress.finish();
        },

        async loadKantor() {
            const { data } = await axios.get("api/kantor/list_kantor_saldo?periode=" + this.tanggal_query);
            console.log(this.$gate)
            this.kantor_list = data.data.data.map((row) => {
                const saldo = row.saldo_akhir?.saldo ?? 0;
                return {
                    ...row,
                    text: row.value,
                    saldo,
                    maksimal: saldo ? parseInt(saldo - parseInt(saldo * 10 / 100)) : 0,
                };
            });
            console.log(this.kantor_list)
        },

        loadKategori() {
            const [tahunpaid, bulanpaid] = [
                this.tanggal_query.slice(0, 4),
                this.tanggal_query.slice(-2),
            ];

            axios
                .get(`api/keuangan/overview`, {
                    params: {
                        kantor_id: this.form.kantor_id.id,
                        tahunpaid,
                        bulanpaid,
                    },
                })
                .then(({ data }) => {
                    this.kategori_list = data.data;
                });
        },

        async loadPejabatApproval() {
            try {

                const response = await axios.get("api/keuangan/pejabat_list");
                this.pejabat_list = response.data.data;

            } catch (error) {
                console.error("Gagal memuat data pejabat:", error);
            }
        },

        loadData() {
            if (this.$gate.isAllowed("is_keuangan")) {
                this.jumlahnya = 0;
                this.jumlahaccept = 0;
                this.jumlahtolak = 0;
                this.jumlahbelum = 0;
                this.jumlahupload = 0;

                this.kategoriBelumTerpilih = true;
                this.kantorBelumTerpilih = true;
                this.loadKantor();
                let tahunpaid = this.tanggal_query.substr(0, 4);
                let bulanpaid = this.tanggal_query.substr(-2, 2);
                axios.get("api/keuangan/permintaan?tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                    if (data.data.length) {
                        this.datas = data.data;
                        this.getStatusnya();
                        this.countJumlahnya();
                    } else {
                        this.datas = [];
                    }
                });
                this.tanggal_tampil = this.getBulan(this.tanggal_query);
            }
        },

        async newModal() {
            this.form.reset();
            this.adaeror = [];

            await this.loadKantor();
            await this.loadPejabatApproval();
            console.log(this.pejabat_list)

            $('#addNew').modal('show');
        },

        createData() {
            this.$Progress.start();
            if (this.form.pejabat_approval.length > 0) {
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                    }
                }
                let formData = new FormData();
                formData.append('datanya', JSON.stringify(this.form));
                axios.post('api/keuangan/addPermintaanPengeluaran?periode='+this.tanggal_query, formData, config)
                    .then((data) => {
                        if (data.data.success) {
                            $('#addNew').modal('hide');

                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                            this.$Progress.finish();
                            this.loadData();
                            this.adaeror = [];
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: 'Some error occured! Please try again'
                            });

                            this.$Progress.fail();
                        }
                    })
                    .catch(e => {
                        this.adaeror = e.response.data.errors;
                        this.$Progress.fail();
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    })
            } else {
                Toast.fire({
                    icon: 'error',
                    title: 'Pejabat Approval Harus Dipilih'
                });

                this.$Progress.fail();
            }

        },

        preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
            }
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        },

        deletePermintaan(id) {
            this.$Progress.start();
            Swal.fire({
                title: 'Yakin untuk menghapus?',
                text: "Hanya Permintaan yang telah ditolak atau belum mendapat respon sama sekali yang dapat dihapus.",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                // Hanya lanjutkan jika pengguna mengonfirmasi penghapusan
                if (result.isConfirmed) {
                    let formData = new FormData();
                    formData.append('datanya', JSON.stringify(id));

                    axios.post('api/keuangan/deletePermintaanPengeluaran', formData)
                        .then((data) => {
                            if (data.data.success) {
                                this.loadData();
                                Swal.fire(
                                    'Terhapus!',
                                    'Data Permintaan Berhasil Dihapus.',
                                    'success'
                                );
                            } else {
                                Swal.fire("Hapus Gagal!", data.message, "warning");
                            }
                            this.$Progress.finish();
                        })
                        .catch(e => {
                            this.$Progress.fail();
                            Swal.fire("Hapus Gagal!", e.response?.data?.message || "Terjadi kesalahan.", "warning");
                        });
                } else {
                    // Batalkan progress bar jika tidak jadi menghapus
                    this.$Progress.finish();
                }
            });
        },
    },

    created() {
        this.$Progress.start();
        this.loadData();
        this.$Progress.finish();
    },
    mounted() {
        this.loadPejabatApproval();
        this.loadKantor();
    }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.progress-group {
    width: 100%;
    margin-bottom: 10px;
    padding-right: 20px;
}

.subtitle {
    font-weight: bold;
    color: #1c1818;
    margin-bottom: 5px;
}

.background-pending,
.background-rejected,
.background-accept,
.background-upload {
    padding: 10px;
    font-weight: bold;
    border-radius: 5px;
    margin-bottom: 5px;
    width: 100%;
    margin-left: auto;
}

.background-pending {
    background-color: #FCE7C8;
    color: black;
}

.background-rejected {
    background-color: #FF9B9B;
    color: black;
}

.background-upload {
    background-color: #C6E7FF;
    color: white;
}

.background-accept {
    background-color: #BFF6C3;
    color: white;
}

.background-pending span,
.background-rejected span,
.background-accept span,
.background-upload span {
    padding: 5px;
    font-size: 14px;
}
</style>